import { render, staticRenderFns } from "./Secret.vue?vue&type=template&id=5f8a3d4e&"
import script from "./Secret.vue?vue&type=script&lang=js&"
export * from "./Secret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports